export interface ProductSeason {
    availability: string
    availabilityStatus: 'green' | 'red' | 'blue'
    code: string
    detail: {
        category: string
        categoryTitle: string
        descriptionShort?: string
        image?: string
        slug: string
        title: string
    }
    price: number
    type: 'season'
    unit: string
}
export default <ProductSeason[]> [
    {
        code: 'BZ00120801',
        detail: {
            title: 'Automatický kávovar ECAM22.360.SB',
            image: 'https://cdn1.idek.cz/dek/img/product/-1887890581.webp',
            descriptionShort: '***tlak 15 bar, příkon 1 450 W***automatická čisticí funkce***nahřívač šálků***vyjímatelná spařovací jednotka***kapacita nádržky na vodu 1,8 l***LatteCrema systém pro krémovou mléčnou pěnu***LCD displej v českém jazyce***dotyková tlačítka***funkce "MY" pro osobní nastavení kávy',
            slug: 'delonghi-ecam22-360-sb',
            category: 'DELONGHI',
            categoryTitle: '',
        },
        price: 518,
        unit: 'ks',
        availability: 'k dispozici 1-5 ks',
        availabilityStatus: 'green',
    },
    {
        code: 'BZ00120823',
        detail: {
            title: 'Automatický kávovar Eletta Cappucicino Evo ECAM46.860B',
            image: 'https://cdn1.idek.cz/dek/img/product/-322963665.webp',
            descriptionShort: '***tlak 15 bar, příkon 1 450 W***automatická čisticí funkce***nahřívač šálků***vyjímatelná spařovací jednotka***kapacita nádržky na vodu 2,0 l***LatteCrema systém pro krémovou mléčnou pěnu***dotykové barevné ikony***LCD displej v českém jazyce',
            slug: 'delonghi-ecam46-860b',
            category: 'DELONGHI',
            categoryTitle: '',
        },
        price: 564,
        unit: 'ks',
        availability: 'k dispozici 1-5 ks',
        availabilityStatus: 'green',
    },
    {
        code: 'BZ00120817',
        detail: {
            title: 'Automatický kávovar Eletta Explore ECAM450.65.S',
            image: 'https://cdn1.idek.cz/dek/img/product/-1965765145.webp',
            descriptionShort: '***tlak 19 bar, příkon 1 450 W***nabídka 50 horkých, ledových a cold brew nápojů stiskem jediného tlačítka***integrovaný mlýnek, 300g zásobník na zrna***karafa LatteCrema Cool pro studenou mléčnou pěnu***technologie Cold Extraction pro přípravu ledového nápoje Cold Brew***funkce To Go pro nápoje s sebou, ve velikosti S, M, L***3,5" TFT dotykový barevný displej***4 uživatelské profily, 5 nastavení aroma, 4 nastavení velikosti nápoje, 3 nastavení teploty***Wi-Fi, app Coffee Link',
            slug: 'delonghi-ecam-450-65-s',
            category: 'DELONGHI',
            categoryTitle: '',
        },
        price: 711,
        unit: 'ks',
        availability: 'k dispozici 1-5 ks',
        availabilityStatus: 'green',
    },
    {
        code: 'BZ00120818',
        detail: {
            title: 'Automatický kávovar Primadonna Elite Experience ECAM650.85.MS',
            image: 'https://cdn1.idek.cz/dek/img/product/132261307.webp',
            descriptionShort: '***tlak 19 bar, příkon 1 450 W***aktivní nahřívač šálků***objem zásobníku 2 l***ocelový mlýnek s 13 stupni hrubosti mletí***LatteCrema systém pro krémovou mléčnou pěnu***široká nabídka nápojů***speciální karafa pro přípravu ledové kávy a horké čokolády***dotykové ovládání pomocí 4,3" TFT barevného displeje***uživatelské profily pro osobní nastavení kávy***provedení z nerezové oceli',
            slug: 'delonghi-ecam-650-85-ms',
            category: 'DELONGHI',
            categoryTitle: '',
        },
        price: 1227,
        unit: 'ks',
        availability: 'k dispozici 1-5 ks',
        availabilityStatus: 'green',
    },
    {
        code: 'BZ00120824',
        detail: {
            title: 'Odvápňovač EcoDecalk',
            image: 'https://cdn1.idek.cz/dek/img/product/102425954.webp',
            descriptionShort: '***obsahuje přírodní a vysoce kvalitní surové materiály, které jsou biologicky odbouratelné***objem: 500 ml pro 4 odvápňovací cykly',
            slug: 'delonghi-ecodecalk',
            category: 'DELONGHI_ACC',
            categoryTitle: '',
        },
        price: 9,
        unit: 'ks',
        availability: 'k dispozici > 5 ks',
        availabilityStatus: 'green',
    },
    {
        code: 'BZ00120807',
        detail: {
            title: 'Pákový kávovar La Specialista Arte EC9155.W',
            image: 'https://cdn1.idek.cz/dek/img/product/-374855164.webp',
            descriptionShort: '***tlak 15 bar, příkon 1 300 W, objem nádržky na vodu 1,5 l, zásobník na kávu 180 g, výška šálku až do 11 cm***8 nastavení mletí, speciálně vyvinutých pro všechny druhy zrnkové kávy***3 stupně teploty vody, které se přizpůsobí různorodosti kávových zrn a stupni jejich pražení***kompletní baristická sada pomáhá eliminovat nepořádek při mletí kávy a pomáhá s precizním pěchováním***parní tryska MyLatte, která je ideální pro hedvábně hladkou mikropěnu a procvičování výtvorů Latte Art',
            slug: 'delonghi-ec9155-w',
            category: 'DELONGHI',
            categoryTitle: '',
        },
        price: 9,
        unit: 'ks',
        availability: 'k dispozici > 5 ks',
        availabilityStatus: 'green',
    },
]
